import React, { createContext, useContext, useState, useEffect } from 'react';
import { normalizeRoleUser } from '../utils_1/roleLocks';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Check if user is logged in on mount
    const token = localStorage.getItem('access_token');
    const userDataStr = localStorage.getItem('user_data');
    
    if (token && userDataStr) {
      try {
        const userData = normalizeRoleUser(JSON.parse(userDataStr));
        setUser(userData);
        localStorage.setItem('user_data', JSON.stringify(userData));
      } catch (e) {
        console.error('Failed to parse user data from local storage', e);
        localStorage.removeItem('access_token');
        localStorage.removeItem('user_data');
      }
    }
    setLoading(false);
  }, []);

  const login = (token, userData) => {
    const normalizedUser = normalizeRoleUser(userData);
    localStorage.setItem('access_token', token);
    localStorage.setItem('user_data', JSON.stringify(normalizedUser));
    setUser(normalizedUser);
  };

  const logout = () => {
    localStorage.removeItem('access_token');
    localStorage.removeItem('user_data');
    setUser(null);
  };

  const getToken = () => {
    return localStorage.getItem('access_token');
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, logout, getToken }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};
